/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ProductFormDeatil/ProductImgPreview.tsx
 * @Description: 商品详情图片预览
 */
import { useState } from 'react';
import { cls } from 'reactutils';
import useUrl from 'hooks/useUrl';
import PlaceholderImage from 'comps/PlaceholderImage';
import GreenTag from 'icons/green/green_tag.svg';
import styles from './ProductImgPreview.module.scss';
interface imageProductTagItem {
  tagName: string;
  tagSortIndex: number;
  tagSysNo: string;
  tagType: number;
}
interface IProps {
  imageProductTag: Array<imageProductTagItem>;
  imgPaths: string[];
  isGreenProduct: boolean;
}
const ProductImgPreview = ({ isGreenProduct, imageProductTag, imgPaths }: IProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { getPublicUrl } = useUrl();
  const handleHover = (url, index) => {
    setActiveIndex(index);
  };
  return (
    <div className={styles.product_intro_l}>
      {imageProductTag
        ? imageProductTag.map((item, index) => (
            <div key={index} className={styles.product_intro_img_tag}>
              {item.tagName}
            </div>
          ))
        : ''}
      <div className="preview">
        <div className={styles.preview_bd}>
          <PlaceholderImage
            height={420}
            width={420}
            src={getPublicUrl(imgPaths && imgPaths[activeIndex])}
          />
        </div>
        <div className={styles.preview_ft}>
          <div className={styles.preview_items}>
            <ul className={styles.preview_items_wrap}>
              {imgPaths?.map((item, index) => (
                <li
                  key={index}
                  className={cls(styles.preview_item, activeIndex === index && styles.active)}
                  onMouseEnter={() => {
                    handleHover(item, index);
                  }}
                >
                  <PlaceholderImage height={67} width={67} src={getPublicUrl(item)} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {isGreenProduct && (
        <div className={styles.green_tag}>
          <GreenTag height={48} width={48} />
        </div>
      )}
    </div>
  );
};

export default ProductImgPreview;
